import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, remove, scrollInfo } from 'kapix-components-vue3'
import hubExpertRessourcesConstruireSupportDeFormationStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'hubExpertRessourcesConstruireSupportDeFormation'
const customImplement: CustomStoreImplementationOptions = hubExpertRessourcesConstruireSupportDeFormationStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function hubExpertRessourcesConstruireSupportDeFormationFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('expert-ressource-4-support-de-formation.title', 'Créer un support de formation'),
        $description: $translate('expert-ressource-4-support-de-formation.description', 'Grâce à Matchers, vous avez toutes les cartes en main pour établir un support de formation structuré avec de bonnes ressources !'),
        $publishedTime: new Date('2023-02-13T07:42:17.696Z'),
        $modifiedTime: new Date('2023-09-14T09:05:13.544Z'),
        // Constants,
        $constants: {
          question1Hidden: false,
          question1Hidden1: null,
          question2Hidden: false,
          question2Hidden1: null,
          question3Hidden: false,
          question3Hidden1: null,
          question4Hidden: false,
          question4Hidden1: null,
          question5Hidden: false,
          question5Hidden1: null,
          k5ObjectifsTxtHidden: false,
          k5ObjectifsTxtHidden1: null,
          k7ConseilsTxtHidden: false,
          k7ConseilsTxtHidden1: null,
          k7ConseilsTxt: '<span style=\'color:hsl(0, 0%, 60%);\'>1 - Établir un sommaire en se basant sur le programme de formation.</span><br><span style=\'color:hsl(0, 0%, 60%);\'>2 - Le construire au fur et à mesure de la formation.</span><br><span style=\'color:hsl(0, 0%, 60%);\'>3 - La taille : trouver le juste milieu.</span><br><span style=\'color:hsl(0, 0%, 60%);\'>4 - Présenter les concepts théorique, le vocabulaire et l\'environnement.</span><br><span style=\'color:hsl(0, 0%, 60%);\'>5 - Puiser et présenter les références que vous connaissez.</span><br><span style=\'color:hsl(0, 0%, 60%);\'>6 - Considérer 20% de théorie et 8°% de pratique.</span><br><span style=\'color:hsl(0, 0%, 60%);\'>7 - Créer des "mémo" pour les cas pratiques. </span>'
        },
        // Data,
        $info: { expertRessource4SupportDeFormation: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      deroulentClick () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      deroulentClickWhenSelected () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container2Click () {
        this.$elements['question-2'].style = { hidden: this.$constants.question2Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container2ClickWhenSelected () {
        this.$elements['question-2'].style = { hidden: this.$constants.question2Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container5Click () {
        this.$elements['question-3'].style = { hidden: this.$constants.question3Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container5ClickWhenSelected () {
        this.$elements['question-3'].style = { hidden: this.$constants.question3Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container8Click () {
        this.$elements['question-4'].style = { hidden: this.$constants.question4Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container8ClickWhenSelected () {
        this.$elements['question-4'].style = { hidden: this.$constants.question4Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container11Click () {
        this.$elements['question-5'].style = { hidden: this.$constants.question5Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container11ClickWhenSelected () {
        this.$elements['question-5'].style = { hidden: this.$constants.question5Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async text7Click () {
        await navigateTo({ hash: '#quest-ce-que-le-support--p46' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text8Click () {
        await navigateTo({ hash: '#k-5-objectifs--p46' })
      },
      /* @ts-ignore: to allow override in your custom file */
      iconeDevDownClick () {
        this.$elements['k-5-objectifs-txt'].style = { hidden: this.$constants.k5ObjectifsTxtHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      iconeDevDownClickWhenSelected () {
        this.$elements['k-5-objectifs-txt'].style = { hidden: this.$constants.k5ObjectifsTxtHidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async text9Click () {
        await navigateTo({ hash: '#k-7-conseils--p46' })
      },
      /* @ts-ignore: to allow override in your custom file */
      icon2Click () {
        this.$elements['k-7-conseils-txt'].style = { hidden: this.$constants.k7ConseilsTxtHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      icon2ClickWhenSelected () {
        this.$elements['k-7-conseils-txt'].style = { hidden: this.$constants.k7ConseilsTxtHidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async text10Click () {
        await navigateTo({ hash: '#bonnes-et-mauvaises-pratiques--p46' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async previewRessourceShortClick () {
        await navigateTo({ name: 'Expert-Ressources-organiser-sa-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element1Click () {
        await navigateTo({ name: 'Expert-Ressources-animer-la-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element2Click () {
        await navigateTo({ name: 'Expert-Ressources-Evaluations' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return hubExpertRessourcesConstruireSupportDeFormationFactory(storeId)()
}

export const hubExpertRessourcesConstruireSupportDeFormationRaw = hubExpertRessourcesConstruireSupportDeFormationFactory()
export const hubExpertRessourcesConstruireSupportDeFormation = () => hubExpertRessourcesConstruireSupportDeFormationRaw() as MergeCustomStore<typeof hubExpertRessourcesConstruireSupportDeFormationStoreCustom.instance>
